import React from "react";
import ExcoPUK from "../../components/organism/ExcoPUK";

const PageExcoPukIndustri = () => {
  return (
    <>
      <ExcoPUK />
    </>
  );
};

export default PageExcoPukIndustri;
